import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/inspectSource';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Re-introspect an already-connected source with its stored credentials.
function* operation(action) {
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/inspect-source/${action.payload.sourceId}`,
      {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
